import originalFetch from 'isomorphic-fetch'
var fetch = require('fetch-retry')(originalFetch);

//解析json
function parseJSON(response) {
    if (response.ok) {
        return response.text().then(function (text) {
            return text ? JSON.parse(text) : response
        })
    } else {
        return response.text().then(function (text) {
            return { 'statusCode': response.status, "msg": text ? JSON.parse(text) : response }
        })
    }
}
//检查请求状态
function checkStatus(response) {
    var url = response.url.toLocaleLowerCase();
    var pathname = window.location.pathname.toLocaleLowerCase();
    //if (response.status === 401 &&
    //    url.indexOf("/v1/auth/") === -1 &&
    //    url.indexOf("/topmenus") === -1 &&
    //    pathname.indexOf("/account/login") === -1 &&
    //    url.indexOf("user/membership") === -1 &&
    //    pathname.indexOf("/download/") === -1 &&
    //    pathname.indexOf("/upload") === -1 &&
    //    pathname.indexOf("/interactivewall") === -1 &&
    //    pathname.indexOf("/transcription") === -1) {
    //    var search=window.location.search.toLocaleLowerCase();
    //    //获取url中puremode的值
    //    if (search.indexOf("?puremode=1")>-1||search.indexOf("&puremode=1")>-1) {
    //        window.location.href = "/account/login?returnUrl=" + encodeURIComponent(pathname + window.location.search)+"&puremode=1";
    //    } else {
    //        window.location.href = "/account/login?returnUrl=" + encodeURIComponent(pathname + window.location.search);
    //    }
    //    return;
    //}
    return response;
}

export function request(options = {}) {
    const { data, url, headers } = options
    options = { ...options }
    options.mode = 'cors'//跨域
    delete options.url
    if (data) {
        delete options.data
        options.body = data
    }
    if (headers) {
        options.headers = headers;
    } else {
        options.headers = {
            'Content-Type': 'application/json',
        }
        let token = localStorage.getItem("token");
        if (token) {
            options.headers.Authorization = "Bearer " + token;
        }
    }
    if (options.method === 'get') {
        options.headers['cache-control'] = 'no-cache'
        options.headers['Pragma'] = 'no-cache'
    }

    options.retries = 3;
    options.retryDelay = 5000;
    options.retryOn = [500];

    return fetch(url, options, { credentials: 'include' })
        .then(checkStatus)
        .then(parseJSON)
        .catch(error => {
            // 处理fetch调用中发生的任何错误
            console.log(error);
            console.error('There has been a problem with your fetch operation:', error);
          });
}